module.exports = __webpack_public_path__ + "static/media/8.e77d9989.png";